/**
 * @file Login route — Auth0 Universal Login redirect (SPA callback is `/login`).
 */
import { Navigate } from "react-router-dom";
import { isSsoConfigured, ssoAudienceMisconfigurationMessage } from "@/auth/sso-env";
import { LoginRedirect } from "./LoginRedirect";

export function LoginPage() {
  const misconfigured = ssoAudienceMisconfigurationMessage();
  if (misconfigured) {
    return (
      <main style={{ padding: 24, maxWidth: 640, fontFamily: "system-ui" }}>
        <h1 style={{ fontSize: "1.25rem" }}>Fix SSO audience</h1>
        <p style={{ lineHeight: 1.5 }}>{misconfigured}</p>
      </main>
    );
  }
  if (!isSsoConfigured()) {
    return <Navigate to="/" replace />;
  }
  return <LoginRedirect />;
}
